// extracted by mini-css-extract-plugin
module.exports = {"container":"_103a151b99--container--hiDGR","avatar":"_103a151b99--avatar--Pm0tK","info":"_103a151b99--info--giYCo"};